import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from "redux";

import { actions } from "store";
import { ProfileForm, ProfileList } from "components/blocks/profile";
import { Button } from "antd";


class ProfileListScreen extends Component {
    showProfileForm = (item = null) => {
        const { actions } = this.props;
        actions.profileShowEditForm({ show: true, object: item });
    };

    render() {
        const { agency, history, match } = this.props;
        const agencyId = parseInt(match.params.id);
        const detail = agency.detail || {};

        return (
            <Fragment>
                <div className="page-content page-content-full">
                    <div className="page-block page-block-full">
                        <ProfileList
                            basePath={`/agency/${agencyId}`}
                            history={history}
                            activeFilter={{ agency: agencyId }}
                            topActions={[
                                <Button type="primary" className="" icon="plus" onClick={() => this.showProfileForm()}>
                                    Добавить анкету
                                </Button>
                            ]}
                        />
                    </div>
                </div>

                <ProfileForm agencyId={agencyId} countryId={detail.country} cityId={detail.city}/>
            </Fragment>
        );
    }
}


function mapStateToProps(state) {
    return {
        agency: state.agency,
    };
}


function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, actions.profile), dispatch),
        dispatch: dispatch
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProfileListScreen);
